"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgTarget32 = function SvgTarget32(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.383.076A1 1 0 0128 1v3h3a1 1 0 01.707 1.707l-4 4A1 1 0 0127 10h-3.586l-5.482 5.482a2 2 0 11-1.414-1.414L22 8.586V5a1 1 0 01.293-.707l4-4a1 1 0 011.09-.217zM24 8h2.586l2-2H27a1 1 0 01-1-1V3.414l-2 2V8z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13c0-1.292-.188-2.539-.538-3.715a1 1 0 011.917-.57A15 15 0 0131 16c0 3.782-1.4 7.238-3.71 9.876l4.417 4.417a1 1 0 01-1.414 1.414l-4.417-4.417A14.943 14.943 0 0116 31c-3.782 0-7.238-1.4-9.876-3.71l-4.417 4.417a1 1 0 01-1.414-1.414l4.417-4.417A14.942 14.942 0 011 16C1 7.716 7.716 1 16 1c1.488 0 2.926.217 4.285.621a1 1 0 11-.57 1.917A13.003 13.003 0 0016 3z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M9 16a7 7 0 018.951-6.725 1 1 0 00.557-1.92 9 9 0 106.125 6.092 1 1 0 00-1.919.566A7 7 0 119 16z",
    fill: "currentColor"
  }));
};

SvgTarget32.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgTarget32;
exports.default = _default;